import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { t } from 'i18next';
import { useCrossWindowMessage } from '@data/hooks/useCrossWindowMessage';
import { useStore } from '@data/other/withStore';
import ModalComponent from '@molecules/BEOffScreen/Modal';
import Button from '@molecules/Button';
import { eventSystem } from '@business/event-system';
import { getExternalPaymentUrl } from '@business/utils/payment';
const ModalExternalPayment = (modalProps) => {
    var _a;
    const { property: { model: propertyModel }, environment: { language }, } = useStore();
    const iframeRef = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [hideFooter, setHideFooter] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(undefined);
    const url = getExternalPaymentUrl(language, (_a = propertyModel === null || propertyModel === void 0 ? void 0 : propertyModel.code) !== null && _a !== void 0 ? _a : '');
    const { postMessage } = useCrossWindowMessage({
        onMessage: (message) => {
            if (message.type === 'cb-bookingengine-payment-page-loaded') {
                setIsModalVisible(true);
                setHideFooter(false);
                return;
            }
            if (message.type === 'cb-bookingengine-payment-processing-status') {
                setIsProcessing(message.payload.isProcessing);
                return;
            }
            if (message.type === 'cb-bookingengine-payment-page-unloaded') {
                setHideFooter(true);
            }
            if (message.type === 'cb-bookingengine-payment-updated') {
                setPaymentMethod(message.payload.method
                    ? message.payload.method
                    : undefined);
            }
        },
    });
    useEffect(() => {
        eventSystem.emit('internal/payment-modal-opened', undefined, {
            visibility: 'internal',
        });
        return () => {
            eventSystem.emit('internal/payment-modal-closed', undefined, {
                visibility: 'internal',
            });
        };
    }, []);
    const isContinueButtonDisabled = useMemo(() => {
        return (!paymentMethod ||
            ['google_pay', 'apple_pay', 'pay_pal'].includes(paymentMethod));
    }, [paymentMethod]);
    const buttons = useCallback((modalProps) => {
        return (_jsxs(_Fragment, { children: [_jsx(Button, { isDisabled: isProcessing, onClick: modalProps.onCancel, variant: "outline", children: t('cancel') }), _jsx(Button, { color: "primary", isDisabled: isContinueButtonDisabled, isLoading: isProcessing, onClick: () => {
                        if (iframeRef.current) {
                            postMessage(iframeRef.current.contentWindow, 'cb-bookingengine-payment-start-command', {});
                        }
                    }, children: t('continue') })] }));
    }, [isContinueButtonDisabled, isProcessing, postMessage]);
    return (_jsx(ModalComponent, Object.assign({}, modalProps, { bodyPadding: false, buttons: buttons, closable: !isProcessing, height: "100%", hideFooter: hideFooter, maskClosable: false, title: t('payments/payment'), visible: isModalVisible, width: 960, children: _jsx("iframe", { height: "100%", ref: iframeRef, src: url, title: t('payments/payment'), width: "100%" }) })));
};
export default ModalExternalPayment;
